enum LogRocketEvents {
  TimeoutServiceWorkerRegister = "TimeoutServiceWorkerRegister",
  TimeoutServiceWorkerInstalled = "TimeoutServiceWorkerInstalled",
  ServiceWorkerNotSupported = "ServiceWorkerNotSupported",
}

export default LogRocketEvents;
